import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AsmConfig } from '@asm/const';
import { AsmComponentService } from '@asm/feature';
import { RoutingService, UserIdService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { FormatTimerPipe } from './format-timer.pipe';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'cx-asm-session-timer',
  templateUrl: './asm-session-timer.component.html',
  imports: [FormatTimerPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AsmSessionTimerComponent implements OnInit, OnDestroy {
  timeLeft: number;
  protected subscriptions = new Subscription();
  protected interval: any;
  protected maxStartDelayInSeconds = 60000;

  constructor(
    protected config: AsmConfig,
    protected asmComponentService: AsmComponentService,
    protected routingService: RoutingService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected userIdService: UserIdService,
  ) {}

  ngOnInit(): void {
    this.timeLeft = this.getTimerStartDelayInSeconds();
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        clearInterval(this.interval);
        this.asmComponentService.logoutCustomerSupportAgentAndCustomer();
      }
      this.changeDetectorRef.markForCheck();
    }, 1000);

    this.resetOnNavigate();
    this.resetOnCustomerSessionChange();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  resetTimer(): void {
    if (this.timeLeft > 0) {
      this.timeLeft = this.getTimerStartDelayInSeconds();
    }
  }

  protected resetOnNavigate(): void {
    this.subscriptions.add(
      this.routingService.isNavigating().subscribe((isNavigating) => {
        if (isNavigating) {
          this.resetTimer();
        }
      }),
    );
  }

  protected resetOnCustomerSessionChange(): void {
    this.subscriptions.add(
      this.userIdService
        .getUserId()
        .pipe(distinctUntilChanged())
        .subscribe(() => this.resetTimer()),
    );
  }

  protected getTimerStartDelayInSeconds(): number {
    if (this.config.asm?.agentSessionTimer?.startingDelayInSeconds === undefined) {
      return 600;
    }
    if (this.config.asm.agentSessionTimer.startingDelayInSeconds > this.maxStartDelayInSeconds) {
      return this.maxStartDelayInSeconds;
    } else {
      return this.config.asm.agentSessionTimer.startingDelayInSeconds;
    }
  }
}
